//保存数据内存
export default{
    user_info: {},//用户信息
    setting:{},//全局配置文件
}